import customAxios from "config";
import { renterError } from "utils/errorMessage";

export const applyCoupon = async (
  coupon: any,
  bookingId: string
): Promise<{ data?: any; error?: string }> => {
  try {
    const response = await customAxios.post<any>(
      `/api/bookings/${bookingId}/apply_coupon/`,
      { coupon_name: coupon }
    );

    return response.data;
  } catch (error) {
    // renterError keeps a renter-safe backend reason ("This coupon has
    // expired") and turns a 404 into "Invalid promo code" — never the old
    // flat "Coupon not found." for every failure.
    return { error: renterError(error, "coupon") };
  }
};
export const removeCoupon = async (
  coupon: any,
  bookingId: string
): Promise<{ data?: any; error?: string }> => {
  try {
    const response = await customAxios.post<any>(
      `/api/bookings/${bookingId}/remove_coupon/`,
      { coupon_name: coupon }
    );

    return response.data;
  } catch (error) {
    return { error: renterError(error, "coupon") };
  }
};
